<ng-template #ieWarning>
  <div style="max-width: 340px">
    <span style="font-weight: bold">Dein Browser (Internet Explorer) unterstützt leider nicht alle Funktionalitäten unserer Anwendung.</span><br />
    <span style="font-size: 0.9rem">
      Wir empfehlen Dir die Verwendung der Browser Chrome, Firefox oder Safari in einer aktuellen Version für mehr Sicherheit, Geschwindigkeit und den besten
      Komfort auf dieser Seite.
    </span>
    <div (click)="dismissIE()" class="white button" style="text-align: center; margin-top: 0.5rem">Okay</div>
  </div>
</ng-template>
<app-login-required-dialog></app-login-required-dialog>

<div class="page-wrap">
  <ng-container>
    <router-outlet></router-outlet>
  </ng-container>
</div>
<app-footer></app-footer>
